const ContactUs = () => {

    return (
        <div className="container mt-5">
            <h2 className="section-title">¿Está interesado?</h2>
            <p>¿Tienes dudas o quieres personalizar tu Asistente?</p>

            <div className="contact-form">
                <form action="https://docs.google.com/forms/d/e/1FAIpQLSeMLaHQDOgw4LgTMj7b6DJGUiWuPexsHiWWpUJ0IBqsZO5GyA/formResponse" method="POST" target="_blank">
                    <label htmlFor="name">Nombre:</label>
                    <input type="text" name="entry.877086558" id="name" required />

                    <label htmlFor="email">Correo electrónico:</label>
                    <input type="email" name="entry.1498135098" id="email" required />

                    <label htmlFor="message">Mensaje:</label>
                    <textarea name="entry.1424661284" id="message" rows="4" required></textarea>

                    <button type="submit">Enviar</button>
                </form>

                <div className="alt-contact">
                    <p>¿Prefieres escribirnos por <a href="https://wa.me/573187073143" target="_blank">WhatsApp</a>?</p>
                </div>
            </div>

        </div>



    )
}

export default ContactUs;